export class ReserveCallbackNotAllowed extends Error {}
